import React from 'react';
import { HOW_IT_WORKS } from '@/data/site';

export default function HowItWorks() {
  return (
    <section className="section-pad bg-ohana-surface" data-testid="how-it-works">
      <div className="container-ohana">
        <div className="max-w-3xl">
          <p className="overline">How It Works</p>
          <h2 className="h-display text-4xl md:text-5xl mt-3 leading-tight">
            Four steps from photos to a clean, empty property.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {HOW_IT_WORKS.map((step, i) => (
            <div
              key={step.n}
              className="relative card-default !p-7 bg-white"
              data-testid={`step-${step.n}`}
            >
              <span className="font-serif text-5xl text-ohana-accent/40 leading-none">
                {step.n}
              </span>
              <h3 className="mt-4 font-serif text-2xl text-ohana-primary leading-snug">
                {step.title}
              </h3>
              <p className="mt-3 text-ohana-text-muted text-sm md:text-base leading-relaxed">
                {step.body}
              </p>
              {step.note && (
                <p
                  className="mt-4 rounded-xl border border-ohana-accent/30 bg-ohana-accent/5 px-4 py-3 text-xs leading-relaxed text-ohana-primary"
                  data-testid={`step-${step.n}-note`}
                >
                  {step.note}
                </p>
              )}
              {i < HOW_IT_WORKS.length - 1 && (
                <span className="hidden lg:block absolute top-10 -right-3 h-px w-6 bg-ohana-accent/50" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
